<template>
  <div class="title_wrapper fl clearfix">
    <div class="title-line fl clearfix">
      <span class="fl">{{titleText}}</span>
      <div class="fl line"></div>
    </div>
    <div class="introduce_text fl">
      推荐行业相关资讯
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
    }
  }
}
</script>

<style lang="scss" scoped>
  .title_wrapper {
    .title-line {
      position: relative;
      height: 39px;
      color: #178ccf;
      font-size: 24px;
      .line {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 104px;
        height: 3px;
        background-color: #178ccf;
      }
    }
    .introduce_text {
      font-size: 14px;
      line-height: 39px;
      margin-left: 20px;
      color: #9c9c9c;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/title.vue